var cardTexts = {
  'sv-SE': {
    ctaButton: 'Välj',
    discount: 'rabatt',
    perPerson: '/person',
    priceDetails: 'Prisdetaljer',
    priceFrom: 'fr. ',
    pricePerPerson: 'Pris per person',
    standard: 'Standard',
    payButton: 'Betala resan',
    totalPrice: 'Resans totalpris',
    futurePayments: 'Kommande betalningar',
    leftToPay: 'Kvar att betala',
    registrationFee: 'Anmälningsavgift',
    finalSum: 'Slutsumma',
    travelDocuments: 'Resedokument',
    addDiscountCode: 'Lägg till rabattkod'
  },
  'nb-NO': {
    ctaButton: 'Velg',
    discount: 'rabatt',
    perPerson: 'pr. person',
    priceDetails: 'Prisinformasjon',
    priceFrom: 'fra ',
    pricePerPerson: 'Pris pr. person',
    standard: 'Standard',
    payButton: 'Betal reisen',
    totalPrice: 'Reisens totalpris',
    futurePayments: 'Kommende betalinger',
    leftToPay: 'Gjenstår å betale',
    registrationFee: 'Depositum',
    finalSum: 'Restbeløp',
    travelDocuments: 'Reisedokument',
    addDiscountCode: 'Legg til rabattkode'
  },
  'da-DK': {
    ctaButton: 'Vælg',
    discount: 'i rabat',
    perPerson: 'pr. person',
    priceDetails: 'Prisdetaljer',
    priceFrom: 'fra ',
    pricePerPerson: 'Pris pr. person',
    standard: 'Standard',
    payButton: 'Betal rejsen',
    totalPrice: 'Rejsens totalpris',
    futurePayments: 'Kommende betalinger',
    leftToPay: 'Restbeløb',
    registrationFee: 'Depositum',
    finalSum: 'Slutbeløb',
    travelDocuments: 'Rejsedokument',
    addDiscountCode: 'Tilføj rabatkode'
  },
  'fi-FI': {
    ctaButton: 'Valitse',
    discount: 'alennus',
    perPerson: '/hlö',
    priceDetails: 'Hintaerittely',
    priceFrom: 'alk. ',
    pricePerPerson: 'Hinta per henkilö',
    standard: 'Luokitus',
    payButton: 'Maksa matka',
    totalPrice: 'Matkan kokonaishinta',
    futurePayments: 'Tulevat maksut',
    leftToPay: 'Maksettavaa',
    registrationFee: 'Varausmaksu',
    finalSum: 'Loppusumma',
    travelDocuments: 'Matkustusasiakirja',
    addDiscountCode: 'Lisää alennuskoodi'
  },
  en: {
    ctaButton: 'Choose',
    discount: 'discount',
    perPerson: '/person',
    priceDetails: 'Price details',
    priceFrom: 'from ',
    pricePerPerson: 'Price per person',
    standard: 'Standard',
    payButton: 'Pay for the trip',
    totalPrice: 'Total price',
    futurePayments: 'Future payments',
    leftToPay: 'Left to pay',
    registrationFee: 'Registration fee',
    finalSum: 'Final sum',
    travelDocuments: 'Travel document',
    addDiscountCode: 'Add discount code'
  }
};
var cardTexts$1 = cardTexts;

export { cardTexts$1 as default };
//# sourceMappingURL=Card.texts.js.map
